<template>
  <v-menu :model-value="isOpen" location="bottom" :close-on-content-click="false" :disabled="disabled" @update:model-value="onMenuToggle">
    <template #activator="{ props: menuProps }">
      <button
        v-bind="menuProps"
        type="button"
        class="text-xs font-medium text-blue-700 hover:underline disabled:text-gray-400 disabled:no-underline"
        :disabled="disabled"
        :aria-label="`Add ${code} capacity for ${weekLabel}`"
      >
        + Add capacity
      </button>
    </template>
    <!-- Exactly the menu the board's "No plan" cell opens, so a week is planned the same way
         from either page — only the activator differs. -->
    <div class="add-plan__popover">
      <NoPlanCellMenu :unit="unit" :previous-week-plan="previousWeekPlan" @copy="onCopy" @add="onAdd" @close="menu.closeMenu(rowId, weekKey)" />
    </div>
  </v-menu>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  import NoPlanCellMenu from '@/components/capacity/NoPlanCellMenu.vue';
  import type { NoPlanMenu } from '@/composables/useNoPlanMenu';

  const props = defineProps<{
    // The panel's single menu instance: only one cell's menu is open at a time, and the
    // create goes through the same store call the board uses.
    menu: NoPlanMenu;
    // The calendar row this type maps to, and the week the plan is created in.
    rowId: string;
    weekKey: string;
    weekLabel: string;
    code: string;
    unit: string | null;
    // The split is saving or halted: no plan can be created until it settles.
    disabled: boolean;
  }>();

  const isOpen = computed(() => props.menu.isMenuCell(props.rowId, props.weekKey));
  const previousWeekPlan = computed(() => (isOpen.value ? props.menu.previousWeekPlan(props.rowId, props.weekKey) : null));

  function onMenuToggle(open: boolean): void {
    if (open) props.menu.openMenu(props.rowId, props.weekKey);
    else props.menu.closeMenu(props.rowId, props.weekKey);
  }

  function onCopy(): void {
    void props.menu.copyPreviousWeek(props.rowId, props.weekKey);
  }

  function onAdd(capacity: number): void {
    void props.menu.addCapacity(props.rowId, props.weekKey, capacity);
  }
</script>

<style scoped>
  .add-plan__popover {
    width: 15rem;
    border: 1px solid rgb(226 232 240);
    border-radius: 0.5rem;
    background: white;
    box-shadow: 0 8px 24px rgb(15 23 42 / 12%);
  }
</style>
